<template>
  <div class="setting_content">
    <div class="setting_content_main">
      <div class="setting_content_heading">
        <h2 class="setting_content_title">
          {{ customizeLabelProperties.TAB_HEADER }}
        </h2>
        <div class="setting_content_heading_btn_holder">
          <button class="setting_btn_outline setting_btn_medium"
                  @click="openCustomizeScreenModal(1)"
                  v-if="selectedTheme !== -1 && searchCustomizeSettings.length !== 0">
            {{ customizeLabelProperties.EDIT_THEME_BUTTON }}
          </button>
          <button class="setting_btn_secondary setting_btn_medium" @click="openCustomizeScreenModal(2)">
            {{ customizeLabelProperties.CREATE_THEME_BUTTON }}
          </button>
          <CustomizeScreenModal
              v-show="isVisibleModalCustomizeScreen"
              :draftColors="draftSearchColors"
              :categoriesSearchJob="categoriesSearchJob"
              :colors="colors"
              :button="button"
              :masters="masters"
              :userId="log.info.userId"
              :groupName="log.groupName"
              :jobPageName="jobPageName"
              :jobOverview="jobOverview"
              :isShowRemoveTheme="isThemeDefault"
              :optionCustomizeColor="optionCustomizeColor"
              :numberOfJobDisplay="numberOfJobDisplay"
              :headingSettings="headingSettings"
              :bodySettings="bodySettings"
              :categoriesJobList="categoriesJobList"
              :categoriesJobDetail="categoriesJobDetail"
              :commonSetting="commonSetting"
              @updateCustomizeSettings="updateCustomizeColors"
              @close="cancelUpdateCustomizeColors"
              @remove="removeCustomizeTheme($event)"
              @setLoggerData="setLoggerData($event)"
          />
        </div>
      </div>
      <p class="setting_content_explain">
        {{ customizeLabelProperties.SUB_HEADER_1 }}
        <br/>
        {{ customizeLabelProperties.SUB_HEADER_2 }}
      </p>
      <div class="setting_theme">
        <ul class="setting_theme_list">
          <li class="setting_theme_item" :id="index"
              v-for="(customize, index) in searchCustomizeSettings" :key="index">
            <label class="setting_theme_label setting_form_radio_label"
                   :class="{ 'is_checked': selectedTheme === customize.id }" v-if="customize.id">
              <div class="setting_theme_box">
                <img
                    class="setting_theme_image"
                    width="120"
                    height="100"
                    :alt="customizeLabelProperties.ALTERNATIVE_DEFAULT_THEME_IMG + indexImgTheme(index)"
                    :src="require('@/assets/img/theme/img_theme' + indexImgTheme(index) + '.svg')"
                />
              </div>
              <input type="radio" :value="customize.id" v-model="computedSelectedTheme"/>
              <span class="setting_form_radio_text setting_word_break">
                {{ customize.themeName }}
              </span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import CustomizeScreenModal from "./ModalComponents/CustomizeScreenModal.vue";
import jobSettingService from "../../../../services/JobSettingService";
import customizeLabelProperties from "../../../../properties/job_screen/customize_tab/customize-labels.json";
import * as generalLabels from "../../../../properties/general_page/generalpage-labels.json";
import * as jobSettingProperty from "../../../../properties/job_screen/job-screen.json";
import * as labelCustomizeProperties
  from "../../../../properties/job_screen/customize_tab/popup-customize/popup-customize-labels.json";
import generalService from "../../../../services/GeneralService";
import customizeMessagesProperties from "../../../../properties/entry_screen/customize_tab/messages.json";

Vue.use(VueToast);
const EDIT_DELETE_THEME = 1;
const CREATE_THEME = 2;

export default {
  name: "CustomizeMode",
  props: [
    "categoriesSearchJob",
    "colors",
    "button",
    "masters",
    "groupName",
    "selectedTheme",
    "searchCustomizeSettings",
    "detailCustomizeSettings",
    "jobPageName",
    "jobOverview",
    "userId",
    "token",
    "numberOfJobDisplay",
    "headingSettings",
    "bodySettings",
    "categoriesJobList",
    "categoriesJobDetail",
    "commonSetting"
  ],
  components: {CustomizeScreenModal},
  data: function () {
    return {
      isThemeDefault: true,
      isVisibleModalCustomizeScreen: false,
      draftSearchColors: {
        borderColor: "#989090",
        keyColor: "#CFC9C9",
        linkText: "#3090D9",
        mainButtonText: "#FFFFFF",
        mainButton: "#F36A07",
        pageBackground: "#FFFFFF",
        pageText: "#0D0D0D",
        subButton: "#F8F7F7",
        subButtonText: "#000000",
        subColor: "#E7E4E4",
        isSystemDefault: false,
        themeName: "",
      },
      customizeLabelProperties: customizeLabelProperties,
      customizeMessagesProperties: customizeMessagesProperties,
      log: {
        info: {},
      },
      optionCustomizeColor: 0
    };
  },
  mounted() {
    if (this.colors.id) {
      const index = this.searchCustomizeSettings.findIndex(item => item.id === this.colors.id);
      this.draftSearchColors = JSON.parse(JSON.stringify(this.searchCustomizeSettings[index]));
    }
  },
  computed: {
    computedSelectedTheme: {
      get() {
        return this.selectedTheme;
      },
      set(val) {
        this.$emit("updatedSelectedTheme", val);
      },
    },
  },
  methods: {
    indexImgTheme(index) {
      if (this.searchCustomizeSettings[index].systemDefault) {
        for (let i = 1; i <= 5; i++) {
          const imgIdx = "0" + i;
          if (this.searchCustomizeSettings[index].themeName.includes(imgIdx)) {
            return imgIdx;
          }
        }
      }

      return "";
    },

    async openCustomizeScreenModal(type) {
      switch (type) {
        case 1: {
          await this.$emit("createLogger", "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.COLOR_THEME_TAB_TITLE + "-Click button " + customizeLabelProperties.EDIT_THEME_BUTTON);
          this.optionCustomizeColor = EDIT_DELETE_THEME;
          const index = this.searchCustomizeSettings.findIndex(item => item.id === this.selectedTheme);
          if (index === -1) {
            return;
          }

          this.isThemeDefault = this.searchCustomizeSettings[index].systemDefault;
          if (this.isThemeDefault) {
            this.draftSearchColors = {
              borderColor: this.searchCustomizeSettings[index].borderColor,
              keyColor: this.searchCustomizeSettings[index].keyColor,
              linkText: this.searchCustomizeSettings[index].linkText,
              mainButtonText: this.searchCustomizeSettings[index].mainButtonText,
              mainButton: this.searchCustomizeSettings[index].mainButton,
              pageBackground: this.searchCustomizeSettings[index].pageBackground,
              pageText: this.searchCustomizeSettings[index].pageText,
              subButton: this.searchCustomizeSettings[index].subButton,
              subButtonText: this.searchCustomizeSettings[index].subButtonText,
              subColor: this.searchCustomizeSettings[index].subColor,
              themeName: this.searchCustomizeSettings[index].themeName + "_コピー",
            };
          } else {
            this.draftSearchColors = JSON.parse(JSON.stringify(this.searchCustomizeSettings[index]));
          }

          break;
        }

        case 2: {
          await this.$emit(
              "createLogger", "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.COLOR_THEME_TAB_TITLE + "-Click button " + customizeLabelProperties.CREATE_THEME_BUTTON
          );
          this.optionCustomizeColor = CREATE_THEME;
          this.draftSearchColors = {
            borderColor: "#989090",
            keyColor: "#CFC9C9",
            linkText: "#3090D9",
            mainButtonText: "#FFFFFF",
            mainButton: "#F36A07",
            pageBackground: "#FFFFFF",
            pageText: "#0D0D0D",
            subButton: "#F8F7F7",
            subButtonText: "#000000",
            subColor: "#E7E4E4",
            themeName: "",
          };

          break;
        }
      }

      this.isVisibleModalCustomizeScreen = true;
    },

    removeCustomizeTheme(hash) {
      if (this.selectedTheme === -1) {
        return;
      }

      const index = this.searchCustomizeSettings.findIndex(item => item.id === this.selectedTheme);
      if (!this.searchCustomizeSettings[index].systemDefault) {
        Vue.$toast.clear();
        Promise.all([jobSettingService.deleteCustomizeTheme(this.searchCustomizeSettings[index].id, hash, this.token), jobSettingService.deleteCustomizeTheme(this.detailCustomizeSettings[index].id, hash, this.token),]).then(() => {
          this.$emit("refreshCustomizeSetting", hash);
          Vue.$toast.success(customizeMessagesProperties.DELETE_THEME_SUCCESS, {
            position: "bottom-right",
            duration: 3000,
          });
        }).catch(e => {
          Vue.$toast.error(customizeMessagesProperties.AN_ERROR_HAS_OCCURRED, {
            position: "bottom-right",
            duration: 3000,
          });

          console.log(e);
        });
      }

      this.isVisibleModalCustomizeScreen = false;
    },

    async updateCustomizeColors(searchColors) {
      await this.$emit("createLogger", "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.COLOR_THEME_TAB_TITLE + "-Popup " + labelCustomizeProperties.HEAD_MODAL + "-Click button " + labelCustomizeProperties.BUTTON_REFLECT);
      let draftDetail = JSON.parse(JSON.stringify(searchColors));
      if (searchColors.id) {
        const index = this.searchCustomizeSettings.findIndex(item => item.id === this.selectedTheme);
        draftDetail.id = this.detailCustomizeSettings[index].id;
      }

      this.$emit("updateCustomizeColors", searchColors, draftDetail, true);
      this.isVisibleModalCustomizeScreen = false;
    },

    async cancelUpdateCustomizeColors(searchColors) {
      await this.$emit("createLogger", "Menu " + generalLabels.THIRD_TAB + "-Tab " + jobSettingProperty.COLOR_THEME_TAB_TITLE + "-Popup " + labelCustomizeProperties.HEAD_MODAL + "-Click button " + labelCustomizeProperties.BUTTON_CLOSE_MODAL);
      let draftDetail = JSON.parse(JSON.stringify(searchColors));
      if (searchColors.id) {
        const index = this.searchCustomizeSettings.findIndex(item => item.id === this.selectedTheme);
        draftDetail.id = this.detailCustomizeSettings[index].id;
      }

      this.$emit("updateCustomizeColors", searchColors, draftDetail);
      this.isVisibleModalCustomizeScreen = false;
    },

    async setLoggerData(action) {
      this.log.groupName = this.groupName;
      this.log.hash = generalService.createHashCode(15);
      this.log.info.action = action;
      this.log.info.path = window.location.href;
      this.log.info.userId = this.userId;
      await this.$emit("sendLogger", this.log);
    },
  },
};
</script>

<style scoped>
.setting_word_break {
  word-break: break-all;
}
</style>

